import React, { Component } from 'react';
import RadioGroup from './RadioGroup.js';
import Label from './Label.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { i as infoIconStyles } from '../InfoIcon-d7b1bb17.js';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';

var css_248z = ".IAo2M{display:block;font-size:16px;line-height:1.5}[dir] .IAo2M{margin:0 0 9px}.ulL1v{align-items:center;display:grid}.ulL1v label{align-items:center;display:inline-flex}[dir] .ulL1v label{margin-top:10px}.ulL1v span{vertical-align:text-bottom}.MSrI2{opacity:.5;pointer-events:none}";
var styles = {"radioGroupVertical_title":"IAo2M","radioGroupVertical_group":"ulL1v","radioGroupVertical_readOnly":"MSrI2"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class RadioGroupVertical extends Component {
  constructor(props) {
    super(props);
    this.id = `h_group_${Math.floor(Math.random() * 9999)}`;
  }
  render() {
    const _a = this.props, { label, tooltipTextKey, t } = _a, props = __objRest(_a, ["label", "tooltipTextKey", "t"]);
    const groupClassName = styles.radioGroupVertical_group;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: infoIconStyles.infoContainer }, label && /* @__PURE__ */ React.createElement(Label, { label, tooltipText: t == null ? void 0 : t(tooltipTextKey) })), /* @__PURE__ */ React.createElement(RadioGroup, __spreadProps(__spreadValues({ ariaLabelledBy: `${this.id}_label` }, props), { className: groupClassName })));
  }
}

export { RadioGroupVertical as default };
//# sourceMappingURL=RadioGroupVertical.js.map
